import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Table from "./Table";
import printerimg from "../../../../assets/print.png"
import {
  useGetVendorAddressListMutation, useGetVendorListMutation,
  usePostCreatePurchaseOrderMutation, usePostItemListMutation,
  usePostSubmitPurchaseOrderMutation, useGetAllShippingAddressesMutation,
  useGetPurchaseOrderByNameMutation,
  useUpdatePurchaseOrderMutation
} from "../../../../store/api/purchaseorderapi";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { useGetSelectedCompanyQuery } from '../../../../store/api/companyapi'
import PrintModal from "../../../../Core/Print/PrintModal";
import BulkUpload from "./BulkUpload";
import Attachment from "../../../../utils/Attachment";
import { useGetScanItemQuery, usePostCreateBulkPickListMutation, usePostCreateBulkPurchaseOrderMutation, usePostSubmitBulkPurchaseOrderMutation } from "../../../../store/api/purchasereturnbulkapi";
import { useNavigate } from "react-router-dom";


const PurchaseForm = () => {
  const nvg = useNavigate();
  const [shipAddr, setShippaddr] = useState([]);
  const [vendor_shipp_address, setVendorshipAddress] = useState()
  const [tab, settab] = useState(1)
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [finalstep, setfinalstep] = useState(false);
   const [rows, setRows] = useState([
  //   {
  //   item_code: "",
  //   item: {},
  //   required_by: "",
  //   quantity: 1,
  //   uom: "",
  //   rate: "0",
  //   amount: "0",
  // }
]);

  const [vendor_list, setvendor_list] = useState([]);
  const [po_response, setpo_response] = useState("");
  const [select_vendor, setselect_vendor] = useState("");
  const [required_date, setrequired_date] = useState("");
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [showpopup, setShowpopup] = useState(false);
  const [podetailWithApi, setpodetailWithApi] = useState(null);
  const [selected_item_data, setselected_item_data] = useState([]);
  const [select_vendor_address, setselect_vendor_address] = useState({});
  const [scanItem, setscanItem] = useState('');
  const [vendor_address_list, setvendor_address_list] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({
    vendor: false,
    vendor_address: false,
    required_date: false,
    items: false
  });
  const [getAllShippingAddresses, { data: addressData, isLoading }] = useGetAllShippingAddressesMutation();
  const [getPurchaseOrderByName] = useGetPurchaseOrderByNameMutation();
  const [createpicklist] = usePostCreateBulkPickListMutation();
  const [getvendor_list] = useGetVendorListMutation();
  const [getitem_list_data] = usePostItemListMutation();
  const [Create_Purchase] = usePostCreatePurchaseOrderMutation();
  const [Create_Bulk_Purchase] = usePostCreateBulkPurchaseOrderMutation();
  const [Submit_Bulk_Purchase] = usePostSubmitBulkPurchaseOrderMutation();
  const [updatePurchaseOrder] = useUpdatePurchaseOrderMutation()
  const [Submit_Purchase] = usePostSubmitPurchaseOrderMutation();
  const [getvendor_address_list_data] = useGetVendorAddressListMutation();
 const [activityboll,setactivityboll] =  useState(false)

  const getVendorAndWarehouse = async () => {
    const venderApiData = await getvendor_list()
    setvendor_list(venderApiData.data.result);
  }
  const { data } = useGetSelectedCompanyQuery();
  const selectedComapny = data?.message?.data?.company;
  const {data:scanItemDetail,refetch:refetchScanItem} = useGetScanItemQuery({ supplier: select_vendor, scan_item: scanItem })
  
  useEffect(() => {
    if (data?.message?.data?.company) {
      const rawCompanyName = data.message.data.company;
      const companyName = rawCompanyName.split(' - ')[0];

      getAllShippingAddresses({ company_name: companyName });
    }
  }, [data, getAllShippingAddresses]);

  useEffect(() => {
    if (addressData?.message) {
      if(addressData.message == "Addresses fetched successfully"){
        const names = addressData?.message.map((item) => ({ name: item.name }));
        setShippaddr(names);
      }
    }
  }, [addressData]);

  const getVendor_Address = async () => {
    try {
      const vendorAddressApiData = await getvendor_address_list_data({ vendor: select_vendor })
      setvendor_address_list(vendorAddressApiData?.data?.result);
      setselect_vendor_address(vendorAddressApiData?.data?.result?.[0])
    } catch (error) {
      console.log("check error", error)
    }
  }


  const gotopicklist = async () =>{
    const data = {"docname":po_response.data.name};
    const response = await createpicklist(data);
    nvg("/inbound-return/purchaseorder/create-pick-list-return-bulk",{state: response.data.message});
  }

  const CreatePurchaseOrder = async () => {

    setFieldErrors({
      vendor: false,
      vendor_address: false,
      required_date: false,
      items: false
    });

    let hasError = false;
    const newErrors = {
      vendor: !select_vendor,
      vendor_address: !(select_vendor_address?.name),
      required_date: !required_date,
      items: selected_item_data.length === 0
    };

    const FirsthasInvalidItem = selected_item_data.some(item => !item.item_code || !item.quantity);
    if (FirsthasInvalidItem) {
      newErrors.items = true;
    }
    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some(error => error);

    if (hasError) {
      setptype("Error");
      setError(FirsthasInvalidItem
        ? 'Please make sure all selected items have Item Code, Required By, Quantity, and Rate.'
        : 'Please fill all required fields before creating the purchase order.');
      setShowError(true);
      return;
    }

    if (!required_date || !select_vendor || !select_vendor_address || selected_item_data.length === 0) {
      setptype("Error")
      setError('Please fill all required fields before creating the purchase order.');
      setShowError(true);
      return;
    }
    const hasInvalidItem = selected_item_data.some(item => !item.item_code || !item.quantity);
    if (hasInvalidItem) {
      setptype("Error")
      setError('Please make sure all selected items have Item Code,Required By, Quantity, and Rate.');
      setShowError(true);
      return;
    }
    const filter_Item_Data = selected_item_data.map(item => ({
      item_code: item.item_code,
      item_name: item.item_name,
      qty: item.quantity,
      rate: item.rate
    }));


    const SenderData = {
      "docstatus": 0,
      "doctype": "Purchase Return Bulk",
      "supplier": select_vendor,
      "posting_date": required_date,
      "address": select_vendor_address.name,
      "supplier_address": vendor_shipp_address ? vendor_shipp_address.name : "",
      "return_table": filter_Item_Data
    }

    try {
      console.log("check send dat4a nn is here",SenderData);
      const ResponseData = await Create_Bulk_Purchase(SenderData)
      console.log("response is her ooo",ResponseData);
      if (ResponseData.error) {
        setptype("Error")
        setError(ResponseData.error?.data?.message);
        setShowError(true);
        return;
      }

      setpo_response(ResponseData.data)
      // const newPO = await getPurchaseOrderByName({ doctype: 'Purchase Order', name: ResponseData.data.data });
      // setpodetailWithApi(newPO.data);
      setptype("Message")
      setError("Purchase Return Saved Successfully");
      setShowError(true);

      // setTimeout(() => {
      //   setptype("Error")
      //   setError("");
      //   setShowError(false);
      // }, 4000);

    } catch (err) {
      console.log("check err", err)

       const apiErrors = [];

    if (err?.data?.message) {
        apiErrors.push(err?.data?.message); 
    } else if (err?.message) {
        apiErrors.push(err?.message);
    } else {
        apiErrors.push("Something went wrong while saving the order.");
    }

    setError(apiErrors);        
    setptype("Error");         
    setShowError(true);
    }
  }

  const SubmitPurchaseOrder = async () => {
    try {
      const ResponseData = await Submit_Bulk_Purchase({ "doc": JSON.stringify(po_response.data),"action":"Submit" })
      console.log("check respons e os response",ResponseData);
      setptype("Message")
      setError("Purchase Order Sumbit Successfully");
      setShowError(true);
      setfinalstep(true)
      setactivityboll(true);
      setTimeout(() => {

        setptype("")
        setError("");
        setShowError(false);
      }, 4000);

    } catch (error) {

    }
  }


  const handleScanItem = async () => {

     if (!required_date || !select_vendor || !select_vendor_address) {
      setptype("Error")
      setError('Please fill all required fields before creating the purchase order.');
      setShowError(true);
      return;
    }
    
    

    const responseScanItem = await refetchScanItem();
    if(!responseScanItem.data.message?.[0]?.item_code){
         setptype("Error");
         setError('Item Not Found');
         setShowError(true);
         return;
    }
    const filterdata = rows.filter((item)=>item.item_code == responseScanItem.data.message[0].item_code);
    console.log("check filterdata is here",filterdata);
    if(filterdata?.[0]?.item_code){
         setptype("Error");
         setError("You cannot add the same item more than once.");
         setShowError(true);
         return;
    }

   const res = await getitem_list_data({ search_input: responseScanItem.data.message[0].item_code, disabled: 0 });
      const quantity = 1;
      const rate = parseFloat(res.data.result?.products?.[0]?.buying_price) || 0;
      const amount = (quantity * rate).toFixed(2);
      const totalqty = responseScanItem.data.message[0].max_allowed_qty;
      const linkGRN = responseScanItem.data.message[0].link_grn;
      setRows(row => [...row,{
        item_code: responseScanItem.data.message[0].item_code,
        item: {...res.data.result.products[0]},
        quantity:quantity,
        rate:rate,
        amount:amount,
        totalqty:totalqty,
        linkGRN:linkGRN}
      ]);

    setselected_item_data(selectedItem => [...selectedItem,{
      item_code: responseScanItem.data.message[0].item_code,
      item: {...res.data.result.products[0]},
      quantity:quantity,
      rate:rate,
      amount:amount,
      totalqty:totalqty,
      linkGRN:linkGRN}
    ]);
  }

  useEffect(() => {
    getVendor_Address()
  }, [select_vendor])

  useEffect(() => {
    getVendorAndWarehouse()
  }, [])



console.log("selected_item_dataselected_item_dataselected_item_dataselected_item_data",selected_item_data,"rowsrowsrows",rows)


  return (
    <FormLayout
      title="New Purchase Return Bulk"
      breadcrumbs={[
        { label: "Inbound" },
        { label: "Purchase Return Bulk List", url: "/inbound/purchaseorder/purchase-orders" }
      ]}
      status={po_response?.data ? 'Draft' : 'New'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {gotopicklist()}}
            // to="/inbound-return/purchaseorder/create-pick-list-return-bulk"
            state={po_response?.data?.name}
            style={{ backgroundColor: '#fff', height: '28px' }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            Create Pick List
          </Button>
         
         
         

         {/* {po_response.data && <Button
            className="custom-btn-00989"
            onClick={UpdatePO}
            iconName="LuFilePlus2"
            style={{ gap: '2px', height: '28px' }}
            iconSize={12}
            display={finalstep ? 'none' : 'flex'}
          >
               Update
          </Button>}  */}

          
          <Button
            className="custom-btn-00989"
            onClick={po_response.data ? SubmitPurchaseOrder : CreatePurchaseOrder}
            iconName="LuFilePlus2"
            style={{ gap: '2px', height: '28px' }}
            iconSize={12}
            display={finalstep ? 'none' : 'flex'}
          >
            {po_response.data ? 'Submit' : 'Save'}
          </Button>

         {po_response && <p className="p-0 m-0">
                        <img src={printerimg} 
                        onClick={() => setShowPrintModal(true)} 
                         className="px-2" style={{width:'35px',cursor:'pointer'}} alt="404" />
                    </p>} 
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">

            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                  General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 2 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                  Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
            </ul>
            {po_response.data && <Attachment doctype="Purchase Order"  docname={po_response.data}  /> }
            

          </div>
        </div>

        <div className="row d-flex justify-content-between " style={{ marginTop: '14px',flexGrow:'1' }}>
          {tab == 1 ? <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1
            ponumber={finalstep}
            activityboll={activityboll} 
            realponumber={po_response?.data?.name}
            vendor={{ vendor_list: vendor_list, setselect_vendor: setselect_vendor, select_vendor: select_vendor, Error: fieldErrors.vendor }} 
            selectedAddress={{ list: vendor_address_list, currentAddress: select_vendor_address, Error: fieldErrors.vendor_address }} 
            required_date={{ setrequired_date: setrequired_date, required_date: required_date, Error: fieldErrors.required_date }} 
            />
          </div> : ''}
          {tab == 1 ? <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
           <div className="d-flex justify-content-between pb-2" style={{ gap: '5px' }}>
            <div className="d-flex align-items-center" style={{ gap: '5px' }}>
              <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {selected_item_data.length}</span></p>
              <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {selected_item_data.reduce((total, item) => { return total + Number(item.quantity); }, 0)}</span></p>
              <p className="ReceivedQty" style={{ display: po_response.data ? '' : 'none' }}>Received Quantity -  <span style={{ color: '#EC642A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}</span></p>
            </div>


             <div className="d-flex">
                <div className="px-2 d-flex" style={{ width: '280px' }}>
                  <input type="text" id="serial-scan-input" className="form-control p-0 px-2"  placeholder="Scan Item Code" value={scanItem}
                    onChange={e => { setscanItem(e.target.value) }}  onKeyDown={e => {
    if (e.key === "Enter") {
      handleScanItem(e);
    }
  }} style={{ fontSize: '0.8rem', height: '34px' }} />
                  <span style={{ position: 'relative', left: "-28px", top: '3px' }}><GetIcon iconName="BsUpcScan" size={15} color="#FF8D5C" /></span>
                </div>
              </div>
            </div>
            <div className="tableLabel">
              <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p className="" style={{ color: "#1E1E1E", fontWeight: '500',fontSize:'15px', marginBottom: '4px' }}>
                Item Details
              </p>
            </div>
            <Table 
            setShowError={setShowError}
            setptype={setptype}
            setError={setError}
            rows={rows}
            setRows={setRows} 
            list_data={getitem_list_data} 
            setselected_item_data={setselected_item_data} 
            po_status={finalstep == false ? '' : 'submited' } />
          </div> : ''}
          
          <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px',overflow:tab == 2 ? "" : 'hidden' }}>
            <Tab2
              read={finalstep}
              // read={po_response?.data}
              status={finalstep ? 'Draft' : 'New'}
              vendor_address={{ vendor_address_list: vendor_address_list, setselect_vendor_address: setselect_vendor_address, currentAddress: select_vendor_address }} 
              shippingAddr={{ setVendorshipAddress: setVendorshipAddress, shippingAddresseslist: shipAddr,currentAddress:vendor_shipp_address }} 
            />
          </div>
        </div>
      </div>

       {showPrintModal && (
                <PrintModal 
                    onClose={() => setShowPrintModal(false)}
                    documentId={po_response?.data}
                     doctype="Purchase Order"
                    title="Print Purchase Order"
                />
            )}
      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />


       <BulkUpload
               show={showpopup}
               onClose={() => setShowpopup(false)}
               rows={rows}
               setRows={setRows}
               setselected_item_data={setselected_item_data}
        />
    </FormLayout>


   
  );
};

export default PurchaseForm;